import { Auth, API } from "aws-amplify";
import { UserInboxItemType } from "@vmosolutions/oc-interfaces";
import { store } from "../redux/store/Store";
import { openSnackbar } from "../redux/actions/App.Actions";
import axios from "axios";

/**
 * This function uploads data to the users inbox. The inbox files are automatically processed server side.
 * @param itemType - The type of item being upload (impacts how the item is processed). User must have permission to do so.
 * @param fileName - The file system name of the file.
 * @param fileType - The file type as reported by the browser.
 * @param lastModified - The browser reported last modified time.
 * @param data  - The data to upload.
 * @param meta - String tuples of meta data to include in the signed url.
 */
export async function uploadToUserInbox(
  itemType: UserInboxItemType,
  fileName: string,
  fileType: string,
  lastModified: number,
  data: ArrayBuffer,
  ...meta: [string, string][]
): Promise<string> {
  try {
    const userSession = await Auth.currentSession();
    const token = userSession.getIdToken().getJwtToken();
    const metaData: Record<string, string> = {
      "oc-itemtype": itemType,
      "oc-clientlastmodified": lastModified.toString(),
      "oc-filename": fileName,
      "oc-filetype": fileType,
    };

    for (let i = 0; i < meta.length; i++) {
      metaData[meta[i][0]] = meta[i][1];
    }

    const params = {
      Metadata: metaData,
    };

    const signedUrl = await API.post("skytrains", "/users/inbox/url", {
      body: params,
      headers: {
        Accept: "*/*",
        Authorization: token,
      },
    });

    const res = await axios.put(signedUrl.url, data, {
      headers: {
        "Content-Type": fileType,
      },
    });

    if (res.status === 200) {
      store.dispatch(
        openSnackbar({
          open: true,
          closeDelay: 3000,
          variant: "success",
          message: `File uploaded successfully: ${fileName}`,
        })
      );
    } else {
      store.dispatch(
        openSnackbar({
          open: true,
          closeDelay: 6000,
          variant: "error",
          message:
            "There was an error uploading your file. Please try again. If the problem persists contact support@vmo.aero",
        })
      );
    }
    return signedUrl.params.Key;
  } catch (err) {
    // FAILURE
    store.dispatch(
      openSnackbar({
        open: true,
        closeDelay: 10000,
        variant: "error",
        message: `File failed to upload: ${fileName}`,
      })
    );
    // Empty string will fail null check on calling function (intended)
    return "";
  }
}
